import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/d2c-sales-tool/src/app/global-error.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UrqlBrowserClientProvider"] */ "/vercel/path0/apps/d2c-sales-tool/src/graphql/UrqlBrowserClientProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/d2c-sales-tool/src/lib/registry.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/d2c-sales-tool/src/styles/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["BugSnagErrorBoundary"] */ "/vercel/path0/apps/d2c-sales-tool/src/utils/bugsnagUtils.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.9.1_@playwright+test@1.58.2_babel-plugin_dlowpd2sszrf2f3qxa7p4njkse/node_modules/next/dist/client/script.js");
